export default "__VITE_ASSET__IEe30C0f__"